import { useState } from 'react';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import { ReactComponent as EyeSVG } from '@/assets/icons/minimal/ic_eye.svg';
import { ReactComponent as EyeOffSVG } from '@/assets/icons/minimal/ic_eye_off.svg';
import { RHFTextField } from '@/components/form-controls/RHFTextField';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
};

// ----------------------------------------------------------------------

export const RHFPasswordTextField = (props: Props) => {
  const { name, label, ...restProps } = props;

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const handlePasswordVisibility = () => setIsPasswordVisible(isVisible => !isVisible);

  return (
    <RHFTextField
      name={name}
      label={label}
      type={isPasswordVisible ? 'text' : 'password'}
      isClearableField={false}
      isCopyableField={false}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handlePasswordVisibility} edge="end">
              {isPasswordVisible ? <EyeOffSVG /> : <EyeSVG />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...restProps}
    />
  );
};
